/**
 * Laatutili controller
 *
 * This class controls OPs laatutili calculator.
 */

 // Use jQuery as $ within this file scope.
const $ = jQuery;

import Dragdealer from './dragdealer';

/**
 * Class Laatutili
 */
export default class Laatutili {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.interest      = 9.95;
        this.updateTimer   = null;
        this.manualInput   = false;
        this.maxAmount     = 50000;
        this.maxTime       = 7;
        this.pageHasSlider = false;
    }

    /**
     * Cache dom elements for use in the class's methods.
     */
    cache() {

        // Amount.
        this.amount = $( '#amount' );

        // Payment.
        this.payment = $( '#payment' );

        // Create slider if amount and payment elements are on the page.
        if ( this.amount.length && this.payment.length ) {
            this.pageHasSlider = true;
            this.slider = new Dragdealer( 'slider_lainan_maara', { animationCallback: this.updateAmount.bind( this ), callback: this.updateAmount.bind( this ) });
        }

    }

    /**
     * All common events.
     */
    events() {
        const self = this;

        // Reflow slider.
        window.onresize( () => {
            this.slider.reflow();
        });

        // Call inputHandler function when amount input field is changed.
        this.amount.change( function( e ) {
            self.inputHandler( e );
        });

    }

    /**
     * Update loan amount.
     *
     * @param {*} x Slider x value.
     * @param {*} y Slider y value.
     */
    updateAmount( x, y ) {

        if ( ! this.manualInput ) {
            this.amount.val( 1000 + ( Math.round( ( ( this.maxAmount - 1000 ) / 500 ) * x ) * 500 ) ).trigger( 'change, input' );
            this.updateTotal();
        }

    }

    /**
     * Update total value.
     * Total value is payment amount per month.
     */
    updateTotal() {
        const loanAmount = parseInt(this.amount.val());
        const loanTime = this.maxTime;
        const interest = this.interest;

        const monthlyPayment = this.calculateMonthlyPayment(loanAmount, loanTime, interest);

        this.payment.html(monthlyPayment + ' \u20AC');
    }

    /**
     * Calculates the monthly payment.
     *
     * @param {number} loanAmount Loan amount in euros.
     * @param {number} loanTime Loan duration in years.
     * @param {number} interest The annual interest rate in percent.
     * @returns {number} The monthly payment in euros, rounded to the nearest whole number.
     */
    calculateMonthlyPayment(loanAmount, loanTime, interest) {
        const months = loanTime * 12;
        const monthlyRate = interest / 100 / 12;

        return Math.round(
            (loanAmount * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months))
        );
    }

    /**
     * Handle input.
     *
     * @param {*} elem Current element.
     */
    inputHandler( elem ) {

        let input = elem.target;

        if ( this.updateTimer != null ) {
            clearTimeout( this.updateTimer );
            this.updateTimer = null;
        }

        this.manualInput = true;

            this.updateTimer = setTimeout( () => {
                let amount = parseInt( input.value );

                if ( isNaN( amount ) || amount < 1000 ) {
                    amount = 1000;
                } else if ( amount > this.maxAmount ) {
                    amount = this.maxAmount;
                }

                this.amount.val( amount );

                if ( this.pageHasSlider ) {
                    this.slider.setValue( ( amount - 1000 ) / ( this.maxAmount - 1000 ), 0, true );
                }

                this.updateTimer = null;

                setTimeout( () => {
                    this.manualInput = false;
                    this.updateTotal();
                }, 1000 );
            }, 500 );

    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();

        // Bind events only if page has slider.
        if ( this.pageHasSlider ) {
            this.events();
        }

    }

}
